import { Icon, IconType, Theme } from '@routific/hive';
import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

const { Colors, Spacing } = Theme;
interface Props {
  isLive: boolean
}

const StyledDiv = styled.div<{ $isLive?: boolean }>`
  height: ${Spacing.mdSpacing};
  border-radius: 12px;
  display: flex;
  font-size: 12px;
  line-height: ${Spacing.mdSpacing};
  padding: 0 ${Spacing.smSpacing} 0 0;
  flex-direction: row;
  gap: ${Spacing.xsSpacing};
  
  color: ${({ $isLive }) => ($isLive ? Colors.success7 : Colors.textSecondary)};
  background-color: ${({ $isLive }) => ($isLive ? Colors.success3 : Colors.gray5)};
`;

const LocationStatusLabel: React.FC<Props> = ({ isLive }) => {
  const { t } = useTranslation('components');

  const getIsLive = () => isLive ? IconType.DriverLocation : IconType.DriverLocationOff;

  return (
    <StyledDiv $isLive={isLive}>
      <Icon icon={getIsLive()} type={isLive ? 'success' : 'secondary'} size="small" fill />
      <span>{isLive ? t('assignDriver.popover.liveLocation') : t('assignDriver.popover.noLocation')}</span>
    </StyledDiv>
  );
};

export default LocationStatusLabel;
